import { ActionLogsService } from './action-logs/action-logs.service';
import { ActionTypesService } from './actions/action-types/action-types.service';
import { AgreementsService } from './agreements/agreements.service';
import { AnnouncementsService } from './announcements/announcements.service';
import { FunctionalRolesService } from './authorization/functional-roles/functional-roles.service';
import { ImportChangesService } from './authorization/import-changes/import-changes.service';
import { PermissionService } from './authorization/permissions/permissions.service';
import { RoleGroupsService } from './authorization/role-groups/role-groups.service';
import { RolesService } from './authorization/roles/roles.service';
import { CommonDataService } from './common-data/common-data.service';
import { CommunitiesService } from './communities/communities.service';
import { CspUtilService } from './csp/csp-util/csp-util.service';
import { EntraAppsService } from './csp/entra-apps/entra-apps.service';
import { LicenseOffersService } from './csp/license-offers/license-offers.service';
import { LicenseTypesService } from './csp/license-types/license-types.service';
import { MpnMappingsService } from './csp/mpn-mappings/mpn-mappings.service';
import { MpnSubscriptionsService } from './csp/mpn-subscriptions/mpn-subscriptions.service';
import { CspSubscriptionsService } from './csp/subscriptions/subscriptions.service';
import { CspTenantsService } from './csp/tenants/tenants.service';
import { CustomersService } from './customers/customers.service';
import { DashboardService } from './dashboard/dashboard.service';
import { DocumentsService } from './documents/documents.service';
import { BranchesService } from './file-management/branches/branches.service';
import { FilesService } from './file-management/files/files.service';
import { IdentityService } from './identity/identity.service';
import { OperationsService } from './job-orchestrator/operations/operations.service';
import { WorkflowsService } from './job-orchestrator/workflows/workflows.service';
import { FieldExpertsService } from './marketing/field-experts/field-experts.service';
import { RecordingsCommunitiesService } from './marketing/recordings/recordings-communities/recordings-communities.service';
import { TopicCommunitiesService } from './marketing/topic-communities/topic-communities.service';
import { NewsTopicsService } from './marketing/topics/news-topics/news-topics.service';
import { AlertLogsService } from './monitoring/alert-logs/alert-logs.service';
import { AlertTypesService } from './monitoring/alert-types/alert-types.service';
import { ConfiguredAlertsService } from './monitoring/configured-alerts/configured-alerts.service';
import { NewsArticleGroupsService } from './news-article-groups/news-article-groups.service';
import { NewsArticlesService } from './news-articles/news-articles.service';
import { NewsCommunitiesService } from './news-articles/news-communities/news-communities.service';
import { NewsArticleLogsService } from './news-logs/news-article-logs.service';
import { ExternalTemplatesService } from './notifications/external-templates/external-templates.service';
import { NotificationLogsService } from './notifications/logs/logs.service';
import { ReceiverGroupsService } from './notifications/receiver-groups/receiver-groups.service';
import { TemplateGroupsService } from './notifications/template-groups/template-groups.service';
import { TemplatesService } from './notifications/templates/templates.service';
import { PartnersService } from './partners/partners.service';
import { CustomerReportsService } from './products-and-orders/customer-reports/customer-reports.service';
import { LinesPrefillService } from './products-and-orders/lines-prefill/lines-prefill.service';
import { OrdersService } from './products-and-orders/orders/orders.service';
import { ProductsService } from './products-and-orders/products/products.service';
import { BcDevRequestsService } from './products-and-orders/requests/bc-dev-requests/bc-dev-requests.service';
import { EmpoweredProductLicensesService } from './products-and-orders/requests/empowered-product-licenses/empowered-product-licenses.service';
import { MmRequestsService } from './products-and-orders/requests/mm-requests/mm-requests.service';
import { RequestsService } from './products-and-orders/requests/requests.service';
import { UsersService } from './users/users.service';

// Signal states
export * from './action-logs/action-logs.store';
export * from './actions/action-types/action-types.store';
export * from './agreements/agreements.store';
export * from './announcements/announcements.store';
export * from './authorization/functional-roles/functional-roles.store';
export * from './authorization/import-changes/import-changes.store';
export * from './authorization/permissions/permissions.store';
export * from './authorization/role-groups/role-groups.store';
export * from './authorization/roles/roles.store';
export * from './common-data/common-data.store';
export * from './communities/communities.store';
export * from './csp/csp-util/csp-util.store';
export * from './csp/entra-apps/entra-apps.store';
export * from './csp/license-offers/license-offers.store';
export * from './csp/license-types/license-types.store';
export * from './csp/mpn-mappings/mpn-mappings.store';
export * from './csp/mpn-subscriptions/mpn-subscriptions.store';
export * from './csp/subscriptions/subscriptions.store';
export * from './csp/tenants/tenants.store';
export * from './customers/customers.store';
export * from './dashboard/dashboard.store';
export * from './documents/documents.store';
export * from './file-management/branches/branches.store';
export * from './file-management/files/files.store';
export * from './identity/identity.store';
export * from './job-orchestrator/operations/operations.store';
export * from './job-orchestrator/workflows/workflows.store';
export * from './marketing/comments/comments.store';
export * from './marketing/events/events.store';
export * from './marketing/field-experts/field-experts.store';
export * from './marketing/topic-communities/topic-communities.store';
export * from './marketing/topics/news-topics/news-topics.store';
export * from './marketing/topics/topics.store';
export * from './monitoring/alert-logs/alert-logs.store';
export * from './monitoring/alert-types/alert-types.store';
export * from './monitoring/configured-alerts/configured-alerts.store';
export * from './news-article-groups/news-article-groups.store';
export * from './news-articles/news-articles.store';
export * from './news-articles/news-communities/news-communities.store';
export * from './news-logs/news-article-logs.store';
export * from './notifications/external-templates/external-templates.store';
export * from './notifications/logs/logs.store';
export * from './notifications/receiver-groups/receiver-groups.store';
export * from './notifications/template-groups/template-groups.store';
export * from './notifications/templates/templates.store';
export * from './partners/partners.store';
export * from './products-and-orders/customer-reports/customer-reports.store';
export * from './products-and-orders/lines-prefill/lines-prefill.store';
export * from './products-and-orders/orders/orders.store';
export * from './products-and-orders/products/products.store';
export * from './products-and-orders/reported-customers/reported-customers.store';
export * from './products-and-orders/requests/bc-dev-requests/bc-dev-requests.store';
export * from './products-and-orders/requests/empowered-product-licenses/empowered-product-licenses.store';
export * from './products-and-orders/requests/mm-requests/mm-requests.store';
export * from './products-and-orders/requests/requests.store';
export * from './users/users.store';

export const ROOT_STATE_SERVICES = [
  IdentityService,
  UsersService,
  ActionLogsService,
  DocumentsService,
  CommonDataService,
  CommonDataService,
  PartnersService,
  PermissionService,
  RolesService,
  RoleGroupsService,
  AgreementsService,
  CustomersService,
  AnnouncementsService,
  BranchesService,
  FilesService,
  ProductsService,
  ReceiverGroupsService,
  ExternalTemplatesService,
  TemplateGroupsService,
  FunctionalRolesService,
  TemplatesService,
  NotificationLogsService,
  NotificationLogsService,
  NewsArticlesService,
  NewsCommunitiesService,
  RecordingsCommunitiesService,
  MmRequestsService,
  CspTenantsService,
  ActionTypesService,
  CspUtilService,
  CustomerReportsService,
  CommunitiesService,
  RequestsService,
  DashboardService,
  LicenseTypesService,
  LicenseOffersService,
  CspSubscriptionsService,
  MpnSubscriptionsService,
  EntraAppsService,
  MpnMappingsService,
  FieldExpertsService,
  AlertLogsService,
  AlertTypesService,
  ConfiguredAlertsService,
  BcDevRequestsService,
  EmpoweredProductLicensesService,
  LinesPrefillService,
  OrdersService,
  NewsArticleGroupsService,
  WorkflowsService,
  OperationsService,
  TopicCommunitiesService,
  NewsTopicsService,
  NewsArticleLogsService,
  ImportChangesService,
];
